import Finance from "./view/finance_view";

export default Finance;
